import office from './office';
import flexibleWorkplace from './flexibleWorkplace';
import fixedWorkplace from './fixedWorkplace';

export default {
  office,
  fixedWorkplace,
  flexibleWorkplace,
};
